// client/src/dnd/emitter_tool/engine/TrailManager.js
export function createTrailManager({ PIXI, mount, getEffectSettings, textures, spriteSource }) {
  const root = new PIXI.Container();
  try { root.sortableChildren = true; } catch {}
  try { root.zIndex = 2050; } catch {}
  if (mount && typeof mount.addChild === "function") mount.addChild(root);

  const nodes = [];
  let emitAccMs = 0;
  let modeCached = "ghost";
  let enabledCached = false;

  function pickTex() {
    const t = (textures && (textures.trail || textures["trail.png"])) ||
              (spriteSource && spriteSource.next && spriteSource.next(0)) ||
              null;
    return t || PIXI.Texture.WHITE;
  }

  function resetAll() {
    for (let i = nodes.length - 1; i >= 0; i--) {
      const n = nodes[i];
      try { root.removeChild(n.s); } catch {}
      try { n.s.destroy?.(); } catch {}
    }
    nodes.length = 0;
    emitAccMs = 0;
  }

  function spawnGhost(pos, es) {
    const spr = new PIXI.Sprite(pickTex());
    spr.anchor.set(0.5);
    spr.position.set(pos.x, pos.y);
    spr.alpha = Number(es.trailAlphaStart ?? 0.5);

    const bm = String(es.blendMode || "NORMAL").toUpperCase();
    spr.blendMode =
      bm === "ADD" ? PIXI.BLEND_MODES.ADD :
      bm === "SCREEN" ? PIXI.BLEND_MODES.SCREEN :
      bm === "MULTIPLY" ? PIXI.BLEND_MODES.MULTIPLY :
      PIXI.BLEND_MODES.NORMAL;

    const scaleStart = Number(es.trailScaleStart ?? 1);
    const widthPx = Number(es.ribbonWidthPx ?? 12);
    const baseW = spr.texture?.width || 32;
    const k = Math.max(0.01, (widthPx / Math.max(1, baseW)) * scaleStart);
    spr.scale.set(k, k);

    root.addChild(spr);
    nodes.push({
      s: spr,
      life: Math.max(0.05, (Number(es.trailLength ?? 8) * Math.max(8, Number(es.trailSpacingMs ?? 30))) / 1000),
      t: 0,
    });

    const limit = Math.max(1, Number(es.trailLength ?? 8));
    while (nodes.length > limit) {
      const old = nodes.shift();
      try { root.removeChild(old.s); } catch {}
      try { old.s.destroy?.(); } catch {}
    }
  }

  function tickGhost(dt, headPos, es) {
    emitAccMs += dt * 1000;
    const spacingMs = Math.max(8, Number(es.trailSpacingMs ?? 30));
    while (emitAccMs >= spacingMs) {
      emitAccMs -= spacingMs;
      if (headPos) spawnGhost(headPos, es);
    }

    const scaleStart = Number(es.trailScaleStart ?? 1);
    const scaleEnd = Number(es.trailScaleEnd ?? 1);
    for (let i = nodes.length - 1; i >= 0; i--) {
      const n = nodes[i];
      n.t += dt;
      const k = Math.max(0, Math.min(1, n.t / n.life));
      const a0 = Math.max(0, Math.min(1, Number(es.trailAlphaStart ?? 0.5)));
      const a1 = Math.max(0, Math.min(1, Number(es.trailAlphaEnd ?? 0)));
      const s0 = Math.max(0.01, scaleStart);
      const s1 = Math.max(0.01, scaleEnd);
      n.s.alpha = a0 + (a1 - a0) * k;
      const sc = s0 + (s1 - s0) * k;
      n.s.scale.set(sc * n.s.scale.x / Math.max(0.01, s0), sc * n.s.scale.y / Math.max(0.01, s0));
      if (n.t >= n.life) {
        try { root.removeChild(n.s); } catch {}
        try { n.s.destroy?.(); } catch {}
        nodes.splice(i, 1);
      }
    }
  }

  function update(dt, headPos) {
    const es = typeof getEffectSettings === "function" ? (getEffectSettings() || {}) : {};
    const enabled = !!es.trailEnabled;
    const mode = String(es.trailMode || "ghost").toLowerCase();

    if (!enabled || !headPos) {
      if (enabledCached) resetAll();
      enabledCached = false;
      return;
    }

    if (!enabledCached) {
      enabledCached = true;
      modeCached = mode;
      resetAll();
    } else if (modeCached !== mode) {
      modeCached = mode;
      resetAll();
    }

    if (mode === "ghost" || mode === "ribbon" || mode === "subemitter") {
      tickGhost(dt, headPos, es);
    }
  }

  function destroy() {
    resetAll();
    try { root.parent && root.parent.removeChild(root); } catch {}
    try { root.destroy({ children: true }); } catch {}
  }

  return { update, destroy, container: root };
}

export default { createTrailManager };
